import type { FC } from "react";

interface TextToCopyProps {
  text: React.ReactNode;
}

export const TextToCopy: FC<TextToCopyProps> = ({ text }) => {
  return (
    <div className="flex w-full cursor-text space-x-2 rounded-md border border-solid border-border-strong bg-slate-50 px-2 py-2 text-xs">
      {text}
    </div>
  );
};
